module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cn":{"myStudent":"我的学生"},"TW":{"myStudent":"我的學生"},"en":{"myStudent":"My Students"}}')
  delete Component.options._Ctor
}
